/**
 * 可按压元素。
 *
 * 存在的意义是把"按压反馈"变成默认行为：以后新增任何按钮，
 * 只要用 Pressable 就自动有按下收缩和松手回弹，不需要记得加动效。
 * 这是把设计规范写进代码，而不是写在文档里。
 */

import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { usePress } from '../motion';

export interface PressableProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	children: ReactNode;
	/** 按下时缩到多少 */
	scale?: number;
	/** 按下时的不透明度，整行等大面积元素用得上 */
	dim?: number;
}

export function Pressable({
	children,
	scale,
	dim,
	className = '',
	type = 'button',
	...rest
}: PressableProps): JSX.Element {
	const ref = usePress<HTMLButtonElement>({ scale, dim });

	return (
		<button ref={ref} type={type} className={className} {...rest}>
			{children}
		</button>
	);
}
